
import { useTranslation } from 'react-i18next';
import Section from '../ui/Section';
import SectionHeader from '../ui/SectionHeader';

const TechStack = () => {
  const { t } = useTranslation();
  
  const techCategories = [
    {
      titleKey: 'languages',
      items: ['Python', 'TypeScript', 'React', 'Django', 'DRF', 'FastAPI', 'Streamlit'],
      color: 'text-blue-400',
    },
    {
      titleKey: 'ai',
      items: ['Claude / Anthropic', 'OpenAI', 'Gemini', 'LangChain', 'MCP', 'RAG', 'Agno', 'n8n'],
      color: 'text-purple-400',
    },
    {
      titleKey: 'databases',
      items: ['PostgreSQL', 'pgvector', 'ChromaDB', 'Redis', 'SQL Server', 'Power BI', 'Supabase'],
      color: 'text-emerald-400',
    },
    {
      titleKey: 'orm',
      items: ['SQLAlchemy', 'Django ORM'],
      color: 'text-orange-400',
    },
    {
      titleKey: 'devops',
      items: ['Docker', 'Celery', 'Git', 'Azure', 'AWS', 'Nginx'],
      color: 'text-cyan-400',
    },
  ];
  
  return (
    <Section id="techstack" background="default">
      <SectionHeader
        title={t('techStack.title')}
        subtitle={t('techStack.subtitle')}
      />
      
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-8">
          {techCategories.map((category) => (
            <div
              key={category.titleKey}
              className="space-y-4"
            >
              <h3 className={`text-lg font-heading font-bold ${category.color} mb-4 text-center lg:text-left`}>
                {t(`techStack.${category.titleKey}`)}
              </h3>
              
              <div className="space-y-2">
                {category.items.map((item) => (
                  <div
                    key={item}
                    className="group"
                  >
                    <div className="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-white/10 border border-white/10 hover:border-primary/50 hover:bg-white/[0.12] hover:shadow-lg hover:shadow-primary/5 transition-all duration-300">
                      <div className="w-1.5 h-1.5 rounded-full bg-primary group-hover:scale-150 group-hover:shadow-sm group-hover:shadow-primary transition-all duration-300" />
                      <span className="text-gray-300 text-sm font-medium group-hover:text-gray-200 transition-colors">{item}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default TechStack;
